import React from 'react'
import { SidebarContainer, Icon, CloseIcon, SidebarWrapper, SidebarMenu, SidebarLink } from './SideElements'

const Sidebar = ({ isOpen, toggle }) => {
    return (

        <SidebarContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle}>
                <CloseIcon />
            </Icon>
            <SidebarWrapper>
                <SidebarMenu>
                    <SidebarLink
                        onClick={toggle}
                        to="about"
                        offset={-80}
                    >Tools</SidebarLink>
                    <SidebarLink

                        onClick={toggle}
                        to="projects"
                        offset={-80}
                    >Projects</SidebarLink>
                    <SidebarLink

                        onClick={toggle}
                        to="contact"
                        offset={-80}

                    >Contact</SidebarLink>
                </SidebarMenu>
            </SidebarWrapper>
        </SidebarContainer>


    )
}

export default Sidebar
